export default __webpack_public_path__ + "static/media/Freebooter's Harness of the Second Caste.2325c800.jpg";